import { HIDDEN_CLASS } from './consts'

import 'intersection-observer'

export default () => {
  const stickyBuyBox = document.querySelector(
    '[data-clientside-hook~="stickyBuyBox"]'
  )
  const variantsContainer = document.querySelector('#h_ProductVariants')

  if (stickyBuyBox && variantsContainer) {
    const IO = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          stickyBuyBox.classList.add(HIDDEN_CLASS)
          return
        }

        if (entry.boundingClientRect.top > 0) {
          stickyBuyBox.classList.add(HIDDEN_CLASS)
        } else {
          stickyBuyBox.classList.remove(HIDDEN_CLASS)
        }
      },
      {
        root: null,
        threshold: 0
      }
    )

    IO.observe(variantsContainer)
  }
}
